import { Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import * as Sentry from '@sentry/angular';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom, Subscription } from 'rxjs';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { ActiveAlarmsPopupComponent } from '../active-alarms-popup/active-alarms-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { MiniMapService } from 'src/app/features/shared/services/MiniMap.service';
import { EnumAlarmCategoriesIcons, EnumAlarmCategoriesValues, EnumAlarmCategory } from 'src/app/features/shared/helpers/enums/EnumAlarmCategories';
import { AlarmCatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/AlarmCatalogPaginationRequest';

import { environment } from "src/environments/environment";
import { ControlPanelService } from '../../../main-dashboard/services/ControlPanel.service';

@Component({
  selector: "alarm-table",
  templateUrl: "./alarm-table.component.html",
  styleUrls: ["./alarm-table.component.css"],
})
export class AlarmTableComponent {
  dummyTableData2 = [
    {
      idAlarm: 5,
      idAlarmCategory: 1,
      alarmCategory: "Geocerca de Monitoreo",
      detonatorName: "Geocerca Este",
      createdIn: "2025/09/04",
      hour: "06:20",
      identifier: "3FAHP0HA6AR123789",
      statusAlarmType: 1, // EnumAlarmCategory.Geocerca_Monitoreo
      priority: "Alta",
      totalTime: "1h 5m",
    },
    {
      idAlarm: 6,
      idAlarmCategory: 2,
      alarmCategory: "Desconexión",
      detonatorName: "---",
      createdIn: "2025/09/03",
      hour: "19:45",
      identifier: "2T1BURHE5JC123456",
      statusAlarmType: 2, // EnumAlarmCategory.Fecha_Desconexión_Mes
      priority: "Baja",
      totalTime: "7d",
    },
    {
      idAlarm: 7,
      idAlarmCategory: 1,
      alarmCategory: "Geocerca de Monitoreo",
      detonatorName: "Geocerca Norte",
      createdIn: "2025/09/05",
      hour: "08:15",
      identifier: "1HGCM82633A123456",
      statusAlarmType: 1,
      priority: "Media",
      totalTime: "30m",
    },
    {
      idAlarm: 8,
      idAlarmCategory: 3,
      alarmCategory: "Sensor de Temperatura",
      detonatorName: "Sensor 1",
      createdIn: "2025/09/06",
      hour: "10:00",
      identifier: "JH4KA8260MC123456",
      statusAlarmType: 3,
      priority: "Alta",
      totalTime: "2h",
    },
  ];

  @Input() tableData;
  @Input() columnHeader;
  filterOptions: { [key: string]: string[] } = {};
  originalFilterOptions: { [key: string]: string[] } = {};
  @Input() catalogPaginationRequest: AlarmCatalogPaginationRequest;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) mainPaginator!: MatPaginator;
  @ViewChild(MatPaginator) noFilterPaginatorBackup!: MatPaginator;

  objectKeys = Object.keys;
  mainDataSource: MatTableDataSource<any>;
  noFilterDataSourceBackup: MatTableDataSource<any>;
  public isLoading = true;
  public hasInactive: boolean = false;

  routeAdd: string;
  routeUpdate: string;
  routeDelete: string;
  mainTotalCount: number;
  filterTotal: number;
  pagina: number = 1;
  filterPage: number = 1;
  filterValue: string = "";
  filtroInput: string = "";
  currentColumn: string;
  filterSearchText: string = "";

  subscription_GetLoading: Subscription;
  subscription_getPage: Subscription;
  subscription_getFilterCount: Subscription;
  subscription_delete: Subscription;
  subscription_getLogById: Subscription;
  constructor(
    private controlAlarmService: ControlPanelService,
    private notifyService: SwalNotificationService,
    private dialog: MatDialog,
    private miniMapService: MiniMapService,
  ) {}

  ngOnInit() {
    this.isLoading = true;
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    if (this.subscription_getPage) this.subscription_getPage.unsubscribe();
    if (this.subscription_getFilterCount)
      this.subscription_getFilterCount.unsubscribe();
    if (this.subscription_delete) this.subscription_delete.unsubscribe();
    if (this.subscription_getLogById)
      this.subscription_getLogById.unsubscribe();
  }

  public setData(data, mainTotalCount) {
    if(!environment.production) console.log("Data tabla", data, mainTotalCount);

    this.mainTotalCount = mainTotalCount;
    this.mainPaginator.length = this.mainTotalCount;
    data.map((item) => {
      item["alarmCategory"] = this.getAlarmCategory(item["alarmCategory"]);
      item["icon"] = this.getAlarmIcon(item["idAlarmCategory"]);
      item["Actions"] = "";
    });
    this.tableData = this.GetCapitalizedKeys(data);
    this.mainDataSource = new MatTableDataSource(this.tableData);
    this.mainDataSource.paginator = this.mainPaginator;
    this.mainDataSource.sort = this.sort;
    this.isLoading = false;
    this.noFilterDataSourceBackup = this.mainDataSource;
    this.noFilterPaginatorBackup = this.mainPaginator;

    if(!environment.production) console.log("Data", this.mainDataSource);
  }

  setFilterOptions(filterOptions) {
    this.filterOptions = filterOptions;
    this.originalFilterOptions = JSON.parse(JSON.stringify(filterOptions));

    if(this.filterOptions['AlarmCategory'] && this.filterOptions['AlarmCategory'].length > 0)
      this.filterOptions['AlarmCategory'].forEach( (item, index) => {
        item = this.getAlarmCategory(item); 
        this.filterOptions['AlarmCategory'][index] = item ? item : this.filterOptions['AlarmCategory'][index];
      });

  }

  GetCapitalizedKeys(data) {
    return data.map((item) => {
      const transformedItem = {};
      Object.keys(item).forEach((key) => {
        transformedItem[key.charAt(0).toUpperCase() + key.slice(1)] = item[key];
      });
      return transformedItem;
    });
  }

  async nextPage(event) {
    //revisa si va a traer datos filtrados
    if (
      (this.catalogPaginationRequest.dato != null &&
        this.catalogPaginationRequest.dato != "") ||
      this.catalogPaginationRequest.filters.length > 0
    ) {
      if (event.pageIndex + 1 > this.filterPage) {
        this.isLoading = true;
        this.catalogPaginationRequest.page = event.pageIndex + 1;
        await this.UpdatePage();
        this.mainPaginator.length = this.filterTotal;
        this.mainDataSource.paginator = this.mainPaginator;
        this.mainDataSource.sort = this.sort;
        setTimeout(() => {
          this.mainPaginator.length = this.filterTotal;
        });
        this.isLoading = false;
        this.filterPage++;
      }
    } else {
      if (event.pageIndex + 1 > this.pagina) {
        this.isLoading = true;
        this.catalogPaginationRequest.page = event.pageIndex + 1;
        await this.UpdatePage();
        this.mainPaginator.length = this.mainTotalCount;
        this.mainDataSource.paginator = this.mainPaginator;
        this.mainDataSource.sort = this.sort;
        setTimeout(() => {
          this.mainPaginator.length = this.mainTotalCount;
        });
        this.isLoading = false;

        this.noFilterDataSourceBackup = this.mainDataSource;
        this.noFilterPaginatorBackup = this.mainPaginator;
        this.pagina++;
      }
    }
  }

  async UpdatePage(): Promise<void> {
    // const capitalizedNewData = this.GetCapitalizedKeys(this.dummyTableData2);
    // this.mainDataSource = new MatTableDataSource(this.mainDataSource.data.concat(capitalizedNewData));
    try {
      const data = await firstValueFrom(
        this.controlAlarmService.getPage(this.catalogPaginationRequest)
      );

      if(!environment.production) console.log("data pagina", data);
      

      if (data.isSuccess) {
        data.result.map((item) => {
          item["IsEditable"] = true;
          item["IsHideable"] = true;
          item["alarmCategory"] = this.getAlarmCategory(item["alarmCategory"] || 1);
          item["icon"] = this.getAlarmIcon(item["idAlarmCategory"]);
          item["Actions"] = "";
        });
        const capitalizedNewData = this.GetCapitalizedKeys(data.result);
        this.mainDataSource = new MatTableDataSource(
          this.mainDataSource.data.concat(capitalizedNewData)
        );
      } else {
        this.notifyService.MessageError("Error en la carga de datos");
        this.isLoading = false;
        throw new Error("Error en la carga de datos");
      }
    } catch (err) {
      console.error("Error en getPage", err);
      throw err;
    }
  }

  async applyFilter(event: any = null) {
    var keyPressed = null;
    if (event != null) {
      keyPressed = event.code;
    } else {
      keyPressed = "Enter";
    }
    
    if (keyPressed != "Enter" && this.filtroInput.length > 0) 
      return;

    this.isLoading = true;
    if (this.filtroInput.length >= 2) {
      //se actualiza el request de paginacion
      this.catalogPaginationRequest.page = 1;
      this.catalogPaginationRequest.dato = this.filtroInput;
      await this.GetFilterFirstPage();
    } else {
      this.catalogPaginationRequest.dato = "";
      if (this.catalogPaginationRequest.filters.length > 0 || this.hasInactive) {
        await this.GetFilterFirstPage();
      }else{
        this.removeFilter();
      }
      this.isLoading = false;
    }
    if (this.mainDataSource.paginator)
      this.mainDataSource.paginator.firstPage();
  }

  async GetFilterFirstPage() {
    this.subscription_getFilterCount = this.controlAlarmService.getCount(this.catalogPaginationRequest).subscribe({
      next: async (data) => {
        if (data.isSuccess == true) {
          this.filterTotal = data.result[0];
          this.mainDataSource = new MatTableDataSource([]);
          await this.UpdatePage();
          this.mainDataSource.paginator = this.mainPaginator;
          this.mainDataSource.sort = this.sort;
          this.mainPaginator.length = this.filterTotal;
          this.isLoading = false;
          this.filterPage = 1;
        }else{
          Sentry.captureMessage('AlarmTable.GetFilterFirstPage: conteo filtrado sin éxito', { level: 'warning', extra: { response: data } });
          this.isLoading = false;
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener conteo filtrado de alarmas', error);
        this.isLoading = false;
      }
    });
  }

  removeFilter() {
    const filterValue = this.filtroInput;
    if (filterValue.length == 0) {
      this.isLoading = true;
      this.mainDataSource = this.noFilterDataSourceBackup;
      this.mainPaginator = this.noFilterPaginatorBackup;
      setTimeout(() => {
        this.mainPaginator.length = this.mainTotalCount;
      });
      this.filterPage = 0;
    }
    this.isLoading = false;
    if (this.mainDataSource.paginator) {
      this.mainDataSource.paginator.firstPage();
    }
  }

  refreshFilter() {
    this.filtroInput = "";
    this.catalogPaginationRequest.dato = "";
    this.catalogPaginationRequest.filters = [];
    this.applyFilter();
  }

  selectChip(column: string, value: string) {
    this.currentColumn = column;
    if (this.columnHeader['AlarmCategory'].activeFilter == value) {
      this.clearColumnFilter();
    }else{
      var index = this.filterOptions[column].indexOf(value);
      var originalValue = this.originalFilterOptions[column][index];
      this.applyColumnFilter(originalValue, value);
    }
  }

  setCurrentColumn(column: string) {
    this.currentColumn = column;
  }

  applyColumnFilter(value: string, displayValue: string = null) {
    const filter: FilterRequest = { key: this.currentColumn, value: value };
    var currentFilter = this.catalogPaginationRequest.filters.find(
      (filter) => filter.key === this.currentColumn
    );
    if (currentFilter) {
      currentFilter.value = value;
    } else {
      this.catalogPaginationRequest.filters.push(filter);
    }
    this.columnHeader[this.currentColumn].activeFilter = displayValue ? displayValue : value;
    this.applyFilter();
  }

  clearColumnFilter() {
    this.catalogPaginationRequest.filters =
      this.catalogPaginationRequest.filters.filter(
        (filter) => filter.key !== this.currentColumn
      );
    this.columnHeader[this.currentColumn].activeFilter = null;
    this.applyFilter();
  }

  handleClick(row, eventType) {
    if (eventType == "edit") {
    }
  }

  getAlarmIcon(alarmType: number) {
    var categoryKey = Object.keys(EnumAlarmCategory).find(
      (key) => EnumAlarmCategory[key] === alarmType
    );

    if (categoryKey) {
      var icon = EnumAlarmCategoriesIcons[categoryKey];
      return icon;
    } else {
      return null;
    }
  }

  getAlarmCategory(alarmCategory: string) {
    var categoryKey = Object.keys(EnumAlarmCategory).find(
      (key) => EnumAlarmCategory[key] === alarmCategory
    );
    if(!environment.production) console.log( "categoryKey", alarmCategory, categoryKey, EnumAlarmCategoriesValues[alarmCategory] );

    if (categoryKey) {
      var category = EnumAlarmCategoriesValues[alarmCategory];
      return category;
    } else {
      return null;
    }
  }

  GetInactives(){
    this.hasInactive = !this.hasInactive;
    this.catalogPaginationRequest.getInactive = this.hasInactive;
    this.applyFilter();
  }

  alarmDetailPopUp(event){
    if(!environment.production) console.log(event);
    
    var idAlarm = event.Id;
    if (event.IdAlarm != null) {
      idAlarm = event.IdAlarm;
    }
    if(!environment.production) console.log(idAlarm);
    const dialogRef = this.dialog.open(ActiveAlarmsPopupComponent, {
      width: "auto",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
      data: {id: idAlarm}
    });
    
    dialogRef.afterClosed().subscribe(reload => {
      if(!environment.production) console.log('cerrado');
      this.miniMapService.deleteMap();
    });
    }
}
